<template>
  <div class="filter-tag" v-if="filterTagData.positive.length || filterTagData.negative.length">
    <div class="multi-select-box">
      <!-- 正面搜索 -->
      <div class="row multi-select" v-if="filterTagData.positive.length">
        <div class="title" @click="checkedAllTagsChange('positive')">全部正面</div>
        <div class="tag-list">
          <div class="tag-list-item" v-for="(item, index) in filterTagData.positive" :key="index">
            <el-dropdown
              :hide-on-click="false"
              :show-timeout="100"
              :hide-timeout="200"
              trigger="hover"
              placement="bottom-start"
              @command="checkedOption"
            >
              <div class="row group-examine">{{item.label}}</div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{option:item,title:'全选'}"
                  :class="item.options.every(v=>v.checked)?'checked-active':''"
                >
                  全选
                  <span class="icon-check-mark" v-if="item.options.every(v=>v.checked)"></span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-for="option in item.options"
                  :key="option.value"
                  :command="{item:option,allDate:item}"
                  :class="option.checked?'checked-active':''"
                >
                  {{option.label}}
                  <span class="icon-check-mark" v-if="option.checked"></span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <!-- 反面搜索 -->
      <div class="row multi-select" v-if="filterTagData.negative.length">
        <div class="title" @click="checkedAllTagsChange('negative')">全部负面</div>
        <div class="tag-list">
          <div class="tag-list-item" v-for="(item, index) in filterTagData.negative" :key="index">
            <el-dropdown
              :hide-on-click="false"
              :show-timeout="100"
              :hide-timeout="200"
              trigger="hover"
              placement="bottom-start"
              @command="checkedOption"
            >
              <div class="row group-examine">{{item.label}}</div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{option:item,title:'全选'}"
                  :class="item.checkAll?'checked-active':''"
                >
                  全选
                  <span class="icon-check-mark" v-if="item.options.every(v=>v.checked)"></span>
                </el-dropdown-item>
                <!-- 不展示 资金预警 -》 债券违约 tag-->
                <template v-for="option in item.options"> 
                  <el-dropdown-item
                    v-if="item.label !== '资金预警' || option.label !== '债券违约'"
                    :key="option.value"
                    :command="{item:option,allDate:item}"
                    :class="option.checked?'checked-active':''"
                  >
                    {{option.label}}
                    <span class="icon-check-mark" v-if="option.checked"></span>
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索结果 -->
    <div class="row dialog-selected" v-if="negative.length || positive.length">
      <div class="selected">已选</div>
      <div @click="onDelAllTag" class="delAllBtn">清空</div>
      <div class="selected-boxss">
        <div class="row selected-tag">
          <div
            @click="onDelTag('positive', tag)"
            class="row positive-tag"
            v-for="tag in positiveArr"
            :key="tag.id"
          >
            <div>{{tag.label}}</div>
            <div class="del-img"></div>
          </div>
        </div>
        <div class="row selected-tag">
          <div
            @click="onDelTag('negative', tag)"
            class="row negative-tag"
            v-for="tag in negativeArr"
            :key="tag.id"
          >
            <div>{{tag.label}}</div>
            <div class="del-img"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      negative: [],
      positive: [],
      filterTagData: {
        positive: [],
        negative: []
      },
      negativeNum: 0,
      positiveNum: 0,
      positiveArr: [],
      negativeArr: []
    };
  },
  props: {
    filterTag: {
      type: Object
    }
  },
  watch: {
    filterTag(val) {
      this.filterTagData = val;
    }
  },
  methods: {
    checkedAllTagsChange(type) {
      this.filterTagData[type].map(v => {
        v.checkAll = true;
        v.options.map(value => {
          value.checked = true;
          return value;
        });
        return v;
      });
      this.checkAllType({
        arr: this.filterTagData[type],
        type
      });
      this.filterTagData = JSON.parse(JSON.stringify(this.filterTagData));
    },
    checkedOption(val) {
      if (val.title && val.title === '全选') {
        val.option.checkAll = !val.option.checkAll;
        val.option.options.map(v => (v.checked = val.option.checkAll));
        this.onCheckAll({
          arr: val.option,
          type: val.option.type === 'positive' ? '全部正面' : '全部负面'
        });
      } else {
        val.item.checked = !val.item.checked;
        val.allDate.checkAll = val.allDate.options.every(v => v.checked);
        this.onEveryChecked({
          arr: val.item,
          type: val.item.type === 'positive' ? '全部正面' : '全部负面'
        });
      }
      this.filterTagData = JSON.parse(JSON.stringify(this.filterTagData));
    },
    onDelAllTag() {
      this.filterTagData.negative.forEach(v => {
        v.checkAll = false;
        v.options.forEach(value => {
          value.checked = false;
        });
      });
      this.filterTagData.positive.forEach(v => {
        v.checkAll = false;
        v.options.forEach(value => {
          value.checked = false;
        });
      });
      this.negative = [];
      this.positive = [];
      this.AllTag();
    },
    onCheckAll(sector) {
      if (sector.type === '全部正面') {
        if (sector.arr.checkAll) {
          sector.arr.options.forEach(v => {
            if (!this.positive.some(item => item.value === v.value)) {
              this.positive.push(v);
            }
          });
        } else {
          this.positive = this.positive.filter(
            v => !sector.arr.options.some(item => item.value === v.value)
          );
        }
      } else if (sector.type === '全部负面') {
        if (sector.arr.checkAll) {
          sector.arr.options.forEach(v => {
            if (!this.negative.some(item => item.value === v.value)) {
              this.negative.push(v);
            }
          });
        } else {
          this.negative = this.negative.filter(
            v => !sector.arr.options.some(item => item.value === v.value)
          );
        }
      }
      this.AllTag();
    },
    onEveryChecked(sector) {
      if (sector.type === '全部正面') {
        // eslint-disable-next-line
        sector.arr.checked
          ? this.positive.push(sector.arr)
          : (this.positive = this.positive.filter(
            v => v.value !== sector.arr.value
          ));
      } else if (sector.type === '全部负面') {
        // eslint-disable-next-line
        sector.arr.checked
          ? this.negative.push(sector.arr)
          : (this.negative = this.negative.filter(
            v => v.value !== sector.arr.value
          ));
      }
      this.AllTag();
    },
    checkAllType(sector) {
      if (sector.type === 'positive') {
        if (sector.arr[0].checkAll) {
          this.positive = [];
          sector.arr.forEach(item => {
            item.options.forEach(v => this.positive.push(v));
          });
        }
      } else if (sector.type === 'negative') {
        if (sector.arr[0].checkAll) {
          this.negative = [];
          sector.arr.forEach(item => {
            item.options.forEach(v => this.negative.push(v));
          });
        }
      }
      this.AllTag();
    },
    AllTag() {
      this.negativeArr = this.negative;
      this.positiveArr = this.positive;
      if (this.negative.length === this.negativeNum) {
        this.negativeArr = [{ label: '全部负面', id: 1 }];
      }
      if (this.positive.length === this.positiveNum) {
        this.positiveArr = [{ label: '全部正面', id: 2 }];
      }
      this.$emit('checkedArr', {
        positive: this.positive.map(v => v.value),
        negative: this.negative.map(v => v.value)
      });
    },
    onDelTag(type, tag) {
      if (type === 'negative') {
        if (tag.label === '全部负面') {
          this.negative = [];
          this.delNegative();
        } else {
          this.negative = this.negative.filter(v => v.value !== tag.value);
          this.delNegative(tag);
        }
      } else if (type === 'positive') {
        if (tag.label === '全部正面') {
          this.positive = [];
          this.delPositive();
        } else {
          this.positive = this.positive.filter(v => v.value !== tag.value);
          this.delPositive(tag);
        }
      }
      this.AllTag();
    },
    delNegative(res = []) {
      if (!res.value) {
        this.filterTagData.negative.forEach(v => {
          v.checkAll = false;
          v.options.forEach(value => {
            value.checked = false;
          });
        });
      } else {
        this.filterTagData.negative.forEach(v => {
          v.options.forEach(value => {
            if (value.value === res.value) {
              value.checked = false;
              v.checkAll = false;
            }
          });
        });
      }
      this.filterTagData = JSON.parse(JSON.stringify(this.filterTagData));
    },
    delPositive(res = []) {
      if (!res.value) {
        this.filterTagData.positive.forEach(v => {
          v.checkAll = false;
          v.options.forEach(value => {
            value.checked = false;
          });
        });
      } else {
        this.filterTagData.positive.forEach(v => {
          v.options.forEach(value => {
            if (value.value === res.value) {
              v.checkAll = false;
              value.checked = false;
            }
          });
        });
      }
      this.filterTagData = JSON.parse(JSON.stringify(this.filterTagData));
    }
  },
  mounted() {
    this.filterTagData = this.filterTag;
    this.negativeNum = 0;
    this.filterTag.negative.forEach(v => {
      this.negativeNum += v.options.length;
    });
    this.positiveNum = 0;
    this.filterTag.positive.forEach(v => {
      this.positiveNum += v.options.length;
    });
    this.negativeNum = this.negativeNum ? this.negativeNum : 999;
    this.positiveNum = this.positiveNum ? this.positiveNum : 999;
  }
};
</script>

<style lang="scss" scoped>
.filter-tag {
  margin-bottom: 24px;
}
.news-list-filter {
  padding: 16px;
}
/deep/ {
  .positive .group-examine {
    &:hover {
      color: #45a8cc !important;
    }
  }

  .positive .title {
    &:hover {
      color: #45a8cc !important;
    }
  }

  .positive .el-checkbox .el-checkbox__label {
    &:hover {
      color: #fe4954 !important;
    }
  }

  .negative .group-examine {
    &:hover {
      color: #45a8cc !important;
    }
  }

  .negative .title {
    &:hover {
      color: #45a8cc !important;
    }
  }
}

.multi-select-box {
  padding: 16px;
  background-color: #f7f8fc;
  .multi-select {
    .title {
      margin-top: 2px;
      padding: 2px 5px;
      min-width: 66px;
      font-size: 14px;
      color: #464d6c;
      &:hover {
        background-color: #ffffff;
        border-radius: 2px;
        cursor: pointer;
        color: #45a8cc !important;
      }
    }
    .tag-list {
      display: flex;
      flex-flow: row;
      flex-wrap: wrap;
      .tag-list-item {
        margin-right: 9px;
        padding: 2px 5px;
        &:hover {
          background-color: #ffffff;
          border-radius: 2px;
          cursor: pointer;
        }
      }
    }
    .group-examine {
      font-size: 14px;
      color: #464d6c;
      &:hover {
        color: #45a8cc !important;
      }
    }
  }
}

/deep/.el-popper {
  margin-top: 0 !important;
  margin-left: -4px;
}
.el-dropdown-menu {
  overflow: auto;
  border: none;
  border-radius: 4px;
  width: 192px;
  max-height: 336px;
  color: rgba(255, 255, 255, 0.7);
  background-color: #ffffff;
  padding: 8px 0;
}
/deep/ {
  .el-dropdown-menu__item {
    padding: 0 14px;
    height: 32px;
    line-height: 32px;
    position: relative;
    .icon-check-mark {
      width: 16px;
      height: 16px;
      background-image: url("../../assets/img/check-mark.svg");
      position: absolute;
      right: 12px;
      top: 8px;
    }
  }
  .checked-active {
    color: #45a8cc !important;
  }
  .el-dropdown-menu__item:hover {
    background-color: #f7f7fa !important;
    color: #595e75;
  }
  .el-checkbox__inner {
    background-color: #000000;
    border: 1px solid rgba(225, 225, 225, 0.3);
  }

  .el-checkbox__label {
    color: rgba(255, 255, 255, 0.7);
  }
}
.dialog-selected {
  padding: 16px 16px 6px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  color: #666666;
  font-size: 14px;
  font-weight: 500;
  background-color: #f7f7fa;
  position: relative;
  .selected {
    padding: 4px 0 0 5px;
    width: 44px;
    color: #464d6c;
    font-weight: 600;
  }
  .delAllBtn {
    width: 52px;
    margin-right: 10px;
    height: 24px;
    padding: 2px 12px;
    border-radius: 2px;
    background-color: #ffffff;
    font-size: 14px;
    position: absolute;
    right: 12px;
    top: 17px;
    color: #464d6c;
    font-weight: 400;
    cursor: pointer;
    &:hover{
      background-color: #45a8cc;
      color:#ffffff;
    }
  }
  .selected-boxss {
    flex: 1;
    flex-wrap: wrap;
    min-height: 34px;
    max-height: 87px;
    overflow: auto;
    padding-right: 52px;
  }
  .selected-tag {
    flex: 1;
    flex-wrap: wrap;
    .industry-tag {
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 2px 12px;
      border-radius: 4px;
      border: solid 1px #4f4e55;
      color: #ffffff;
      font-size: 14px;
    }
    .positive-tag {
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 2px 8px;
      border-radius: 2px;
      border: solid 1px #e2e2e2;
      color: #747990;
      font-size: 14px;
      cursor: pointer;
      flex-wrap: wrap;
    }
    .negative-tag {
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 2px 8px;
      border-radius: 2px;
      border: solid 1px #e2e2e2;
      color: #747990;
      font-size: 14px;
      cursor: pointer;
    }
    .neutral-tag {
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 2px 12px;
      border-radius: 4px;
      border: solid 1px #4f4e55;
      color: #ffffff;
      font-size: 14px;
    }
    .del-img {
      margin-left: 4px;
      margin-top: 2px;
      width: 16px;
      height: 16px;
      background: url("../../assets/img/del-hover.svg") no-repeat;
      background-size: cover;
      cursor: pointer;
      &:hover{
         background: url("../../assets/img/del-img.svg") no-repeat;
      }
    }
  }
}
</style>
